import React from 'react';
import ReactDOM from 'react-dom'
import Header from '../../component/header'
import GTip from '../../component/gTip'
import FloatMenu from '../../component/floatMenu'
import Seckill from './component/seckill'
import SecList from './component/secList'
import { AppContext, defaultState } from '../../config/context'
import '../../common/util/channel'
import '../../common/util/polyfill'
import initReportEnv from '../../common/util/report'

initReportEnv('STEAM专区')

class App extends React.Component {
    constructor() {
        super()
        this.updateUserInfo = user => {
            this.setState(state => ({
                user: {
                    ...state.user,
                    ...user
                }
            }))
        }
        this.state = {
            ...defaultState,
            updateUserInfo: this.updateUserInfo
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <Header></Header>
            <Seckill></Seckill>
            <SecList secName="商品一览"></SecList>
            <GTip></GTip>
            <FloatMenu></FloatMenu>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))